import { ENDPOINT } from "../../constants/server/api";
import { fetchApiData } from "../../utils/apiUtils";
import * as reportSlice from "../slices/report.slice";

export const getBillReport = (buisnessSlug, params) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.REPORT}/bill/pagination/${buisnessSlug}/list`,
    params: params,
    dispatch,
  });
  if (data) {
    await dispatch(reportSlice.clearBillReport());
    await dispatch(reportSlice.setBillReport(data));
  }
  return data;
};

export const getBillReportExcel =
  (buisnessSlug, params, date) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.REPORT}/bill/excel/${buisnessSlug}`,
        params: params,
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `รายงาน${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const getSaleReport = (buisnessSlug, params) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.REPORT}/sales/list/${buisnessSlug}`,
    params: params,
    dispatch,
  });
  if (data) {
    await dispatch(reportSlice.clearSaleReport());
    await dispatch(reportSlice.setSaleReport(data));
  }
  return data;
};

export const getSaleReportExcel =
  (buisnessSlug, params, date) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.REPORT}/sales/excel/${buisnessSlug}`,
        params: params,
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `รายงานขาย${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const getDebtorReport = (businessId, params) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.REPORT}/debtor/pagination/${businessId}/list`,
      params: params,
      dispatch,
    });
    if (data) {
      return data;
    }
  } catch (error) {
    console.error(error);
  }
};

export const getDebtorReportExcel =
  (businessId, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.REPORT}/debtor/excel/${businessId}`,
        params: params,
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `รายงานลูกหนี้.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

export const getBillReportById = (id) => async (dispatch) => {
  try {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.REPORT}/bill/${id}`,
      dispatch,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getSingleSalesReport =
  (businessSlug, branchId, branchPosId, date) => async (dispatch) => {
    try {
      const params = {
        branchId,
        branchPosId,
        date,
      };

      const data = await fetchApiData({
        method: "get",
        endpoint: `${ENDPOINT.REPORT}/sales/single/${businessSlug}`,
        params: params,
        dispatch,
      });

      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

export const getSalesProductReport =
  (businessSlug, params) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.REPORT}/sales-product`,
      params: {
        businessSlug,
        startDate: params.startDate,
        endDate: params.endDate,
        ...(params.branchId && { branchId: params.branchId }),
        ...(params.productCategoryId && {
          productCategoryId: params.productCategoryId,
        }),
        ...(params.productSubCategoryId && {
          productSubCategoryId: params.productSubCategoryId,
        }),
        ...(params.s && { s: params.s }),
        ...(params.sortBy && { sortBy: params.sortBy }),
        ...(params.sortOrder && { sortOrder: params.sortOrder }),
      },
      dispatch,
    });
    return data;
  };

export const exportSalesProductReport =
  (businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "get",
        endpoint: `${ENDPOINT.REPORT}/sales-product/export`,
        params: {
          businessSlug,
          ...params,
        },
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        const dateRange =
          params.startDate && params.endDate
            ? `_${params.startDate}_to_${params.endDate}`
            : "";
        link.setAttribute(
          "download",
          `sales_by_product_report${dateRange}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };
